export default __webpack_public_path__ + "static/media/mainSubscription.f2c32253.svg";